import { useState } from "react";

/* Un botón que pregunta antes de hacer, EN EL MISMO LUGAR.
 *
 * Para lo que no tiene vuelta atrás desde la pantalla —anular un trabajo del
 * puerto, borrar una tarea—: el primer toque no hace nada, cambia el botón por
 * «¿Anular? · Sí, anular · No». Es el mismo paso que ya dan Automatizaciones
 * («¿Borrarla?… Sí, borrar / No») y las hojas de Mi espacio, sacado a un
 * componente porque en una tabla hay uno por fila y cada fila pregunta por la
 * suya.
 *
 * SIN `window.confirm`: el cartel del navegador tapa la fila por la que
 * pregunta, y en el teléfono se cierra con el mismo dedo que lo abrió.
 *
 * `children` es lo que dice el botón; `pregunta` y `si`, lo que aparece al
 * tocarlo. Lo demás (`title`, `aria-label`…) va al botón tal cual.
 */
export default function BotonConfirmar({
  children,
  pregunta = "¿Seguro?",
  si = "Sí",
  no = "No",
  className,
  claseSi = className,
  claseNo = className,
  disabled = false,
  onConfirmar,
  ...resto
}) {
  const [preguntando, setPreguntando] = useState(false);

  if (!preguntando) {
    return (
      <button
        type="button"
        className={className}
        disabled={disabled}
        onClick={() => setPreguntando(true)}
        {...resto}
      >
        {children}
      </button>
    );
  }

  return (
    <span
      role="group"
      aria-label="Confirmar"
      style={{ display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
    >
      {pregunta}
      <button
        type="button"
        className={claseSi}
        disabled={disabled}
        onClick={() => {
          setPreguntando(false);
          onConfirmar?.();
        }}
      >
        {si}
      </button>
      <button type="button" className={claseNo} onClick={() => setPreguntando(false)}>
        {no}
      </button>
    </span>
  );
}
